import { OrganizationDefaultsResponse } from '@/modules/common/types/dto/response/organization-defaults.response';

import { Currency } from '../types/currency';
import { OrganizationDefaults } from '../types/organization-defaults';
import { mapRateSourceFromDTO } from './rate-source.mapper';

/**
 * Maps organization defaults response from API to application domain model.
 */
export const mapOrganizationDefaultsFromResponse = (
  response: OrganizationDefaultsResponse
): OrganizationDefaults => {
  return {
    currency: new Currency(response.currency.code, response.currency.displayName),
    organizationRate: response.organizationRate,
    projectRateSource: mapRateSourceFromDTO(response.projectRateSource),
    useRateSourceOnProject: mapRateSourceFromDTO(response.useRateSourceOnProject),
  };
};
